module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "size": 'lg',
      "title": "Welcome to Parlay!!",
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "flex flex-grow items-center justify-center h-full overflow-auto"
  }, [_c('iframe', {
    attrs: {
      "width": "80%",
      "height": "80%",
      "src": 'https://www.youtube.com/embed/qPKEiK-Qp7Y'
    }
  })]), _vm._v(" "), _c('footer', {
    staticClass: "flex flex-col items-center justify-center pb-5"
  }, [_c('button', {
    staticClass: "bg-primary px-5 py-2 rounded text-white text-lg font-semibold",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n      Let´s Get Started!\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mt-1"
  }, [_c('a', {
    staticClass: "hover:underline text-xs text-primary",
    attrs: {
      "href": "https://parlayideas.com/how-it-works/",
      "target": "_blank"
    }
  }, [_vm._v("\n        How it works\n      ")]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-external-link-alt text-primary",
    staticStyle: {
      "font-size": "8px"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6f253070!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/dashboard/ModalAfterSignUp.vue
// module id = 1883
// module chunks = 61